export enum QuestionFilter {
    NONE = "NONE",
    NAO_RESPONDIDA = "NAO_RESPONDIDA",
    RESPONDIDA = "RESPONDIDA",
    FAVORITAS = "FAVORITAS"
}
